exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".above-header[data-v-1b497e56]{position:relative;z-index:10;width:100%;min-height:45px;background:#99a2fb;box-shadow:0 7px 22px rgba(68,65,254,.15);display:flex;justify-content:center;align-items:center;font-family:Roboto;font-style:normal;font-weight:700;font-size:16px;line-height:19px;padding:10px}.above-header a[data-v-1b497e56]{color:#fff;text-align:center}.above-header a[data-v-1b497e56]:hover{text-decoration:underline}.above-header__new[data-v-1b497e56]{background:linear-gradient(117.21deg,#ff3998 20.22%,#ff6c3e 86.27%);box-shadow:0 2px 5px rgba(127,15,215,.25);border-radius:30px;color:#fff;padding:3px 10px;font-size:14px;margin-right:10px;cursor:default}@media (max-width:500px){.above-header__new[data-v-1b497e56]{display:none}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1b497e56","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./app/Sites/AT/assets/js/vue/components/header/AboveHeader.vue
// module id = 123
// module chunks = 0 1